module.exports = __webpack_public_path__ + "img/resource-center-empty-state.dd9c763d.svg";